<template>
  <v-row>
    <v-col cols="12" class="py-0">
      <ComponentsFixedBar :minimized-side-menu="minimizedSideMenu" :title="$t('general.actions')"/>
    </v-col>
    <v-col cols="12" style="padding-top: 50px!important;" v-if="historicalActions && historicalActions.length > 0">
      <v-list two-line class="transparent py-0">
        <template v-for="(action, index) in historicalActions">
          <v-list-item :key="action._id" class="kbLight mb-1">
            <v-list-item-action>
              <v-icon :color="mainColor" size="25px">{{ formatHistoryText(action.type).icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="kbDarkBlueText--text">{{ formatHistoryText(action.type).text }}</v-list-item-title>
              <v-list-item-subtitle>{{ action.createdAt | moment('DD/MM/YYYY hh:mm a') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider :key="action._id" v-if="index < historicalActions.length - 1"/>
        </template>
      </v-list>
    </v-col>

    <v-col class="d-flex justify-center align-center"
           cols="12"
           style="padding-top: 50px!important"
           v-else>
      <div style="width: 100%">
        <div class="pb-2 d-flex justify-center align-center">
          <v-icon :color="mainColor" size="45px" class="mr-2">mdi-clipboard-list-outline</v-icon>
        </div>
        <span class="kbGray--text text-center d-block"
              style="font-size: 18px; margin: 0 auto"
              :style="{ maxWidth: $vuetify.breakpoint.smAndDown ? '100%' : '70%' }">
          {{ $t('general.noPersonRecords') }}
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import ComponentsFixedBar from '@/pages/App/People/dialogs/ViewUser/ComponentsFixedBar'
export default {
  components: { ComponentsFixedBar },
  computed: {
    ...mapState({
      historicalActions: state => state.users.historicalActions
    })
  },
  async created () {
    await this.getUserHistoricalActions()
  },
  methods: {
    formatHistoryText (item) {
      switch (item) {
        case 'register_facebook':
          return { icon: 'mdi-facebook', text: 'Registro con Facebook' }
        case 'register_email':
          return { icon: 'mdi-email-outline', text: 'Registro con Email' }
        case 'register_instagram':
          return { icon: 'mdi-instagram', text: 'Registro con Instagram' }
        case 'register_spotify':
          return { icon: 'mdi-email-outline', text: 'Registro con Spotify' }
        case 'register_google':
          return { icon: 'mdi-google', text: 'Registro con Google' }
        case 'login_facebook':
          return { icon: 'mdi-facebook', text: 'Inicio de sesión con Facebook' }
        case 'login_email':
          return { icon: 'mdi-email-outline', text: 'Inicio de sesión con Email' }
        case 'login_instagram':
          return { icon: 'mdi-instagram', text: 'Inicio de sesión con Instagram' }
        case 'login_spotify':
          return { icon: 'mdi-email-outline', text: 'Inicio de sesión con Spotify' }
        case 'login_google':
          return { icon: 'mdi-google', text: 'Inicio de sesión con Google' }
        case 'logout':
          return { icon: 'mdi-login', text: 'Cierre de sesión' }
        default:
          return { icon: 'mdi-bell-outline', text: item }
      }
    },
    async getUserHistoricalActions () {
      await this.$store.dispatch('getHistoricalOfUserActions', this.userId)
    }
  },
  props: {
    history: {
      type: Array,
      default: () => []
    },
    mainColor: {
      type: String
    },
    minimizedSideMenu: {
      type: Boolean,
      required: true
    },
    userId: {
      type: String
    }
  }
}
</script>
